import { render, staticRenderFns } from "./ModalModelForm.vue?vue&type=template&id=7381588c&"
import script from "./ModalModelForm.vue?vue&type=script&lang=js&"
export * from "./ModalModelForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports